import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { IconButton, Alert as MuiAlert, } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { XIcon } from '../../icons';
import clsx from 'clsx';
export var styles = function (theme) { return ({
    sizeSmall: {
        fontWeight: 300,
        paddingTop: theme.spacing(0.5),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(0.5),
        '& .MuiAlert-icon': {
            width: 16,
            height: 16,
            lineHeight: 1,
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 300,
            marginRight: theme.spacing(1),
        },
        '& .MuiAlert-action': {
            paddingTop: 0,
            paddingLeft: theme.spacing(0.5),
        },
        '& .MuiAlert-message': {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 0.9,
        },
    },
    icon: {},
    message: {},
    action: {},
}); };
/**
 * @public
 */
export var Alert = forwardRef(function (_a, ref) {
    var onClose = _a.onClose, action = _a.action, closeText = _a.closeText, _b = _a.classes, classes = _b === void 0 ? {} : _b, classNameProp = _a.className, size = _a.size, props = __rest(_a, ["onClose", "action", "closeText", "classes", "className", "size"]);
    var sizeSmall = classes.sizeSmall, restClasses = __rest(classes, ["sizeSmall"]);
    var className = clsx(size === 'small' && sizeSmall, classNameProp);
    return (React.createElement(MuiAlert, __assign({ className: className, classes: restClasses }, props, { ref: ref, action: action !== null && action !== void 0 ? action : (onClose && (React.createElement(IconButton, { size: "small", "aria-label": closeText, title: closeText, color: "inherit", onClick: onClose },
            React.createElement(XIcon, { size: size === 'small' ? 12 : 21 })))), onClose: onClose })));
});
// @ts-expect-error https://material-ui.com/guides/composition/#wrapping-components
Alert.muiName = MuiAlert.muiName;
export default withStyles(styles, { name: 'BwAlert' })(Alert);
/** @private @internal for docs only! */
export var DocsAlert = function (props) { return React.createElement(Alert, __assign({}, props)); };
//# sourceMappingURL=Alert.js.map